import { create } from 'zustand';

/**
 * Navigation Store
 * Manages the Hub & Spoke navigation state for F&B OS.
 */
const useNavigationStore = create((set) => ({
  activeTab: null,
  isGridView: true,
  history: [], // Stack for breadcrumbs/back navigation

  // Actions
  navigateTo: (tab) => set((state) => {
    if (!tab) return { activeTab: null, isGridView: true, history: [] };
    
    // Add current tab to history before moving to next (if not already there)
    const newHistory = [...state.history];
    if (state.activeTab && state.activeTab !== tab) {
      newHistory.push(state.activeTab);
    }

    return { 
      activeTab: tab, 
      isGridView: false,
      history: newHistory
    };
  }),

  goBack: () => set((state) => {
    if (state.history.length === 0) {
      return { activeTab: null, isGridView: true, history: [] };
    }

    const newHistory = [...state.history];
    const prevTab = newHistory.pop();

    return {
      activeTab: prevTab,
      isGridView: !prevTab,
      history: newHistory
    };
  }),

  resetToHub: () => set({
    activeTab: null,
    isGridView: true,
    history: []
  }),
  
  setInitialState: (tab, isGridView) => set({
    activeTab: tab,
    isGridView: isGridView,
    history: []
  })
}));

export default useNavigationStore;
